(() => {
  const init = (wrap) => {
    if (!wrap || wrap.dataset.ddInit === "1") return;

    const head = wrap.querySelector(".bcpo-label");
    const opts = Array.from(wrap.querySelectorAll(":scope > label"));
    if (!head || opts.length === 0) return;

    wrap.dataset.ddInit = "1";

    // Options in Panel packen (für Height-Animation)
    const panel = document.createElement("div");
    panel.className = "bcpo-panel";
    opts.forEach((l) => panel.appendChild(l));
    wrap.appendChild(panel);

    // a11y + Pfeil-Status via CSS (aria-expanded)
    head.setAttribute("role", "button");
    head.tabIndex = 0;
    head.setAttribute("aria-expanded", "false");

    let open = false;

    const openPanel = () => {
      open = true;
      head.setAttribute("aria-expanded", "true");
      panel.style.height = panel.scrollHeight + "px";

      const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        panel.style.height = "auto";
        panel.removeEventListener("transitionend", onEnd);
      };
      panel.addEventListener("transitionend", onEnd);
    };

    const closePanel = () => {
      open = false;
      head.setAttribute("aria-expanded", "false");
      panel.style.height = panel.scrollHeight + "px";
      requestAnimationFrame(() => (panel.style.height = "0px"));
    };

    const toggle = () => (open ? closePanel() : openPanel());

    // Start: zu
    panel.style.height = "0px";

    head.addEventListener("click", (e) => {
      e.preventDefault();
      toggle();
    });

    head.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggle();
      }
    });

    // Optional: nach Auswahl wieder zuklappen
    wrap.addEventListener("change", (e) => {
      if (e.target && e.target.matches('input[type="radio"]')) closePanel();
    });
  };

  const scan = (root = document) => {
    root.querySelectorAll(".selector-wrapper.bcpo-radios").forEach(init);
  };

  const ready = () => {
    scan();

    // Falls BCPO später nachlädt / neu rendert
    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        m.addedNodes.forEach((n) => {
          if (!(n instanceof HTMLElement)) return;
          if (n.matches?.(".selector-wrapper.bcpo-radios")) init(n);
          else scan(n);
        });
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });

    // Shopify Theme Editor (Sections reload)
    document.addEventListener("shopify:section:load", () => scan());
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
})();
